// tslint:disable-next-line:no-console
export const { log } = console;
